export default "__VITE_ASSET__BLJs9n$6__"